"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFieldSet = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FormFieldMixin = require("../../mixins/components/FormFieldMixin");
var StyledFieldSet = /*#__PURE__*/_styledComponents.default.fieldset.withConfig({
  displayName: "StyledFieldSet",
  componentId: "c11n-8-107-0__sc-151qck5-0"
})(["", ""], _FormFieldMixin.FormFieldMixin);
exports.StyledFieldSet = StyledFieldSet;